import React from 'react';
import { IActionType } from '../connectedForm/Hooks/usePerformSave';

type ActionButtonContextType = {
  individualButtons: boolean;
  performSave?: (action?: IActionType, values?: any) => any;
};

//Context to be provided by Workspace, Form or ActionButtons.js to define criteria for action button display.
//e.g. Whether or not the Button should be displayed as Borderless (To be in a dropdown).
const ActionButtonContext = React.createContext({ individualButtons: false } as ActionButtonContextType);
export default ActionButtonContext;
